import 'bootstrap';

// Functie voor het instellen van een cookie
function setCookie(name, value, lifetime_days) {
    var exp = new Date();
    exp.setDate(new Date().getDate() + lifetime_days);
    document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
}

// Functie voor het ophalen van een cookie
function getCookie(name) {
    if (document.cookie) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(name + '=') === 0) {
                return cookie.substring(name.length + 1);
            }
        }
    }
}

// Initialisatie van Swiper voor verschillende carrousels
function initSwiper(selector, options) {
    if (jQuery(selector)[0]) {
        new Swiper(selector, options);
    }
}

// Initialisatie van Plyr voor videospeler
const player = new Plyr('#player', {
    controls: [
        'play-large', 'play', 'progress', 'current-time',
        'captions', 'settings', 'pip', 'airplay', 'fullscreen'
    ]
});

// Initialisatie van Swiper voor product carrousel
initSwiper(".productSwiper", {
    direction: 'horizontal',
    slidesPerView: '2',
    spaceBetween: 30,
    loop: true,
    navigation: {
        nextEl: '.next-product',
    },
    breakpoints: {
        576: { slidesPerView: 2, slidesPerColumn: 2 },
        992: { slidesPerView: 3, slidesPerColumn: 3 },
        1400: { slidesPerView: 4, slidesPerColumn: 4 }
    }
});

// Initialisatie van Swiper voor logo carrousels
initSwiper(".customerSwiper, .branding-swiper", {
    slidesPerView: 2,
    slidesPerColumn: 2,
    autoplay: { delay: 10000, disableOnInteraction: false },
    breakpoints: {
        576: { slidesPerView: 4, slidesPerColumn: 4 },
        992: { slidesPerView: 4, slidesPerColumn: 4 },
        1400: { slidesPerView: 4, slidesPerColumn: 4 }
    }
});

// Initialisatie van Swiper voor gerelateerde items
initSwiper(".related-swiper", {
    slidesPerView: 2,
    slidesPerColumn: 2,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
        1200: { slidesPerView: 3, slidesPerColumn: 3, spaceBetween: 30, loop: true }
    }
});

// Initialisatie van Swiper voor reviews
initSwiper(".review-slides", {
    slidesPerView: 1,
    slidesPerColumn: 1,
    effect: 'fade',
    loop: true,
    autoHeight: true,
    fadeEffect: { crossFade: true },
    navigation: { nextEl: ".next-slide" }
});

// Event listeners voor togglen van klassen
jQuery(document).ready(function () {
    jQuery(".notification .close").on('click', function () {
        setCookie('notify', '1', 7);
        jQuery('.notification').slideUp(200);
    });

    jQuery(".darkmode-toggle").on('click', function () {
        const isDarkmode = jQuery(this).hasClass('darkmode-toggle');
        Cookies.set('darkmode', isDarkmode ? '1' : '', { expires: isDarkmode ? 7 : -1, path: '/' });
        jQuery('main, header, footer').toggleClass('darkmode', isDarkmode);
    });

    jQuery(".newsletter-popup-toggle").on('click', function () {
        jQuery('#newsletter-popup').toggleClass('popup-active');
    });

    jQuery(".widget-title").on('click', function () {
        jQuery(this).toggleClass('is-open').next('div').slideToggle(300);
    });

    jQuery(".mobile-nav-toggle").on('click', function () {
        jQuery(this).toggleClass('mobile-nav-open');
        jQuery('nav#mobile').slideToggle(300).toggleClass('is-open');
    });

    jQuery("nav#mobile .has-mega-menu, nav#mobile .menu-item-has-children").on('click', function () {
        jQuery(this).toggleClass('sub-is-open').find('.mega-menu, ul.sub-menu').slideToggle(400).toggleClass('is-open');
    });

    jQuery(".applyToggle").on('click', function () {
        jQuery('.applyFormPop').fadeIn(300).toggleClass('popUpOpen');
    });

    jQuery(".closePopUp").on('click', function () {
        jQuery('.applyFormPop').fadeOut(300).removeClass('popUpOpen');
    });
});
